module.exports = __webpack_public_path__ + "img/9207733.jpg";